module.exports = __webpack_public_path__ + "static/img/none.5e4d1301.png";